import styled from 'styled-components';
import { CustomRatioImage } from '../../../../../components/image/CustomRatioImage';
import { useQueryParamsHook } from '../../../../../utils/useQueryParamsHook';
import { useReturnExchangeDownloadFormsValueContextHook } from '../../contexts/ReturnExchangeDownloadFormsContext';
import CustomBlockButton from '../../../../../components/button/CustomBlockButton';
import { useState } from 'react';
import { ModalDelete } from './modals/modal-delete';
import { useApiInfoContextValueHook } from '../../../../../contexts/ApiInfoContext';
import { SellertoolSignatureUtils } from '../../../../../utils/sellertool-signature-utils';
import { useFetcher } from '../../fetcher/useFetcher';
import { ReturnExchangeDownloadFormsApi } from '../../../../../apis/ReturnExchangeDownloadFormsApi';
import { CustomBackdropController } from '../../../../../components/backdrop/default/v1';
import { CustomPopover, useCustomPopoverHook } from '../../../../../components/popover/CustomPopover';
import { ModalCopyCreate } from './modals/modal-copy-create';

const StyledContainer = styled.div`
    padding: 10px;
`;

const StyledWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(4,1fr);
    gap: 10px;
`;

const StyledCard = styled.div`
    position: relative;
    padding: 10px;
    border: 1px solid #e0e0e0;
    min-height: 100px;
    border-radius: 3px;
    background-color: #fff;

    .floating{
        position: absolute;
        top: 5px;
        right: 5px;
        width: 30px;
        height: 30px;
        cursor: pointer;
    }

    .title{
        font-size:20px;
        font-weight: 700;
        color:#333;
    }

    .description{
        margin-top: 15px;
        font-size:14px;
        font-weight: 500;
        color:#666;
        min-height: 50px;
        

        display: -webkit-box;        
        -webkit-line-clamp: 3;       
        -webkit-box-orient: vertical;
        overflow: hidden;            
        white-space: pre-wrap;
        word-wrap: break-word;
        line-height: 1.4;            
    }

    .buttons{
        display: flex;
        gap: 10px;
        justify-content: flex-end;

        & button{
            width: 70px;
            height: 38px;
            border-radius: 3px;
            border: 1px solid #333;
            color: #333;
            font-weight: 600;

            &.delete{
                background-color: var(--redColor1);
                border:none;
                color: #fff;
            }
        }
    }
`;

const StyledPlusIcon = styled.div`
    width: 80px;
    height: 80px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    border: 1px dashed #333;
    border-radius: 50%;
`;

const StyledPopover = styled.div`
    button{
        width: 150px;
        height: 38px;
        border-radius: 3px;
        border: 1px solid #333;
        color: #333;
        font-weight: 600;
        background-color: #fff;
    }
`;

export function WegetList(props) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const fetcher = useFetcher();
    const queryParamsHook = useQueryParamsHook();
    const returnExchangeDownloadFormsValueContextHook = useReturnExchangeDownloadFormsValueContextHook();
    const returnExchangeDownloadForms = returnExchangeDownloadFormsValueContextHook?.returnExchangeDownloadForms;
    const popoverHook = useCustomPopoverHook();

    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [copyCreateModalOpen, setCopyCreateModalOpen] = useState(false);
    const [selectedDownloadForm, setSelectedDownloadForm] = useState(null);

    const handleMoveToCreate = () => {
        queryParamsHook.setSearchParams({ viewType: 'CREATE' });
    }

    const handleMoveToEdit = (_id) => {
        queryParamsHook.setSearchParams({ viewType: 'EDIT', returnExchangeDownloadFormId: _id });
    }

    const handleOpenDeleteModal = (archive) => {
        setSelectedDownloadForm(archive);
        setDeleteModalOpen(true);
    }

    const handleCloseDeleteModal = () => {
        setSelectedDownloadForm(null);
        setDeleteModalOpen(false);
    }

    const handleDelete = async () => {
        const timestamp = Date.now().toString();
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp
        })

        const headers = {
            'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
            'x-sellertool-timestamp': timestamp,
            'x-sellertool-signiture': signature
        }

        const body = {
            _id: selectedDownloadForm?._id
        }
        CustomBackdropController().showBackdrop();

        const response = await ReturnExchangeDownloadFormsApi().deleteOne({ headers: headers, body: body });
        if (response?.content) {
            fetcher.fetchReturnExchangeDownloadForms();
            handleCloseDeleteModal();
        }

        CustomBackdropController().hideBackdrop();
    }

    const handleCopyCreateModalOpen = (item) => {
        popoverHook.closePopover();
        setCopyCreateModalOpen(true);
        setSelectedDownloadForm(item);
    }

    const handleCopyCreateModalClose = () => {
        setCopyCreateModalOpen(false);
        setSelectedDownloadForm(null);
    }

    return (
        <>
            <StyledContainer>
                <StyledWrapper>
                    <StyledCard
                        style={{ border: '1px dashed #333', cursor: 'pointer' }}
                        onClick={() => handleMoveToCreate()}
                    >
                        <StyledPlusIcon>
                            <CustomRatioImage>
                                <CustomRatioImage.Image src="/assets/icons/add_default_000000.svg" alt="placeholder" />
                            </CustomRatioImage>
                        </StyledPlusIcon>
                    </StyledCard>
                    {returnExchangeDownloadForms?.map((item, index) => {
                        return (
                            <StyledCard key={index}>
                                <div className='floating' onClick={(e) => popoverHook.openPopover(e, item)}>
                                    <CustomRatioImage>
                                        <CustomRatioImage.Image src="/assets/icons/line-menu-more-vertical-svgrepo-com.svg" alt="placeholder" />
                                    </CustomRatioImage>
                                </div>
                                <div className='title'>
                                    {item.name}
                                </div>
                                <div className='description' title={item.description}>
                                    {item.description}
                                </div>
                                <div className='buttons'>
                                    <CustomBlockButton
                                        type='button'
                                        onClick={() => handleMoveToEdit(item?._id)}
                                    >
                                        수정
                                    </CustomBlockButton>
                                    <CustomBlockButton
                                        type='button'
                                        className='delete'
                                        onClick={() => handleOpenDeleteModal(item)}
                                    >
                                        삭제
                                    </CustomBlockButton>
                                </div>
                            </StyledCard>
                        );
                    })}
                </StyledWrapper>
            </StyledContainer>

            {deleteModalOpen &&
                <ModalDelete
                    open={deleteModalOpen}
                    onClose={handleCloseDeleteModal}
                    onDelete={handleDelete}
                />
            }

            {copyCreateModalOpen &&
                <ModalCopyCreate
                    open={copyCreateModalOpen}
                    onClose={() => handleCopyCreateModalClose()}
                    selectedDownloadForm={selectedDownloadForm}
                />
            }

            {popoverHook.anchorEl &&
                <CustomPopover
                    anchorEl={popoverHook.anchorEl}
                    onClose={() => { popoverHook.closePopover() }}
                >
                    <StyledPopover>
                        <CustomBlockButton
                            type='button'
                            onClick={() => handleCopyCreateModalOpen(popoverHook.element)}
                        >
                            복사생성
                        </CustomBlockButton>
                    </StyledPopover>
                </CustomPopover>
            }
        </>
    );
}